import MENTOR_STATUS, { MentorStatusValues } from 'enums/MentorStatus';
import { FC } from 'react';
import Chip from '../Chip';

type Props = {
  status: MentorStatusValues;
};
const MentorStatusChip: FC<Props> = ({ status }) => {
  switch (status) {
    case 'TRAINING':
      return (
        <Chip bgColor="#F4F3FF" color="#5925DC">
          {MENTOR_STATUS[status]}
        </Chip>
      );
    case 'TRAINING_REGISTERED':
      return (
        <Chip bgColor="#FDF2FA" color="#C11574">
          {MENTOR_STATUS[status]}
        </Chip>
      );
    case 'FILLING_FORM':
    case 'SIGNING_CHART':
      return (
        <Chip bgColor="#FFF6ED" color="#C4320A">
          {MENTOR_STATUS[status]}
        </Chip>
      );
    case 'ACCEPTED':
      return (
        <Chip bgColor="#ECFDF3" color="#027A48">
          {MENTOR_STATUS[status]}
        </Chip>
      );
    case 'AVAILABLE':
      return (
        <Chip bgColor="#ECFDF3" color="#027A48">
          {MENTOR_STATUS[status]}
        </Chip>
      );
    case 'REFUSED':
      return (
        <Chip bgColor="#FEF3F2" color="#B42318">
          {MENTOR_STATUS[status]}
        </Chip>
      );
    case 'MENTORSHIP_ACTIVE':
      return (
        <Chip bgColor="#F0F9FF" color="#026AA2">
          {MENTOR_STATUS[status]}
        </Chip>
      );
    default:
      return null;
  }
};

export default MentorStatusChip;
